import { GlobalErrorHandler } from './interceptors/global-error-handler';
import { BaseComponent } from './base.component';
import { AuthService } from './services/auth.service';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { HttpCustomInterceptor } from './interceptors/http-custom.interceptor';
import {
  APP_INITIALIZER,
  ErrorHandler,
  NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpRequestLoaderInterceptor } from './interceptors/loader-spinner-interceptor';
import { ErrorHandlerInterceptor } from './interceptors/error-interceptor.service';
import { of, lastValueFrom } from 'rxjs';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        BaseComponent,
    ],
    providers: [
        AuthService,
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestLoaderInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpCustomInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorHandlerInterceptor,
            multi: true,
        },
        // Below initializer should not be used going forward as the refresh logic is handled in Refresh Guard..
        // {
        //   provide: APP_INITIALIZER,
        //   useFactory: initAuthentication,
        //   multi: true,
        //   deps: [AuthService, TranslateService, Router],
        // },
        // {
        //   provide: LOCALE_ID,
        //   useFactory: (translate: TranslateService) => {
        //     configureLocale(translate);
        //     return translate.getDefaultLang();
        //   },
        //   deps: [TranslateService],
        // },
        {
            provide: APP_INITIALIZER, useFactory: setLocale,
            deps: [TranslateService],
            multi: true,
        },
    ],
})
export class CoreModule {}

export function setLocale(translateService: TranslateService) {
  return (): void => {
    const defaultLocal = 'en';
    const userLang = navigator.language;
    const sessionStorageLang = localStorage.getItem('lang');
    if (sessionStorageLang?.includes('en') || sessionStorageLang?.includes('fr')) {
      translateService.setDefaultLang(
        sessionStorageLang?.includes('en') ? 'en' : 'fr'
      );
    } else if (userLang.includes('en') || userLang.includes('fr')) {
      translateService.setDefaultLang(userLang?.includes('en') ? 'en' : 'fr');
    } else {
      translateService.setDefaultLang(defaultLocal);
    }
    localStorage.setItem('lang', translateService.getDefaultLang());
    translateService.use(translateService.getDefaultLang());
  };
}

export function configureLocale(translateService: TranslateService) {
  const localId: string = 'en';
  const userLang = navigator.language;
    const sessionStorageLang = localStorage.getItem('lang');
    if (
      sessionStorageLang?.includes('en') ||
      sessionStorageLang?.includes('fr')
    ) {
      translateService.setDefaultLang(
        sessionStorageLang?.includes('en') ? 'en' : 'fr'
      );
    } else if (userLang.includes('en') || userLang.includes('fr')) {
      translateService.setDefaultLang(userLang?.includes('en') ? 'en' : 'fr');
    } else {
      translateService.setDefaultLang(localId);
    }

    localStorage.setItem('lang', translateService.getDefaultLang());
    translateService.use(translateService.getDefaultLang());

}

export function initAuthentication(
  authService: AuthService,
  _translateService: TranslateService
) {
  return () => {
    if (localStorage.getItem('token')) {
      // verify token
      return lastValueFrom(authService.fetchProfile())
        .then(( configuration: any) => {
          // translateService.setDefaultLang(authService.getUser().language); // read user preferred language
          // translateService.use(authService.getUser().language); // read user preferred language
          //   localStorage.setItem('lang', authService.getUser().language ?? 'en'); // read user preferred language
          return configuration;
        })
        .catch(( error: any) => {
          console.error(error);
        });
    } else {
      return of(null);
    }
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/translations/', '.json');
}
